import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLinkedin, FiCalendar, FiMail } = FiIcons;

const TeamPage = () => {
  const executiveTeam = [
    {
      name: 'Quintin Lee',
      title: 'Chief Executive Officer',
      bio: 'Visionary leader with 10+ years of experience in organizational strategy, leadership development, and strategic communications. Recognized for building global partnerships and leading the development of international training programs and strategic communications campaigns that drive growth and influence across diverse environments.',
      image: 'https://cqpenfycgbztkozuwfiu.supabase.co/storage/v1/object/sign/Professional%20Photos/IMG_0099.JPG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9kZjlmMTQ4My1mMmM0LTRjZTAtOWIxNi01N2E0Njk3ZWIxYjciLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJQcm9mZXNzaW9uYWwgUGhvdG9zL0lNR18wMDk5LkpQRyIsImlhdCI6MTc1NTg3NzM4MiwiZXhwIjozMzI5MTg3NzM4Mn0.KhpR9jRLQrsjdaNaFR30SDeLLFRiYfeobJR0kDB8iLM',
      social: {
        linkedin: 'https://www.linkedin.com/in/quintin-lee/',
        calendar: 'https://lunacal.ai/team/quantum-leverage',
        email: 'quintin@quantumleverage.com'
      }
    },
    {
      name: 'Oualid Ouardi',
      title: 'Chief Technology Officer',
      bio: 'AI governance and operational transformation expert with 15+ years scaling €100B+ financial institutions through AI, NLP, intelligent automation, and digitalization, delivering 25-40% efficiency gains under strict regulatory requirements. Recently advised the UN Development Coordination Office on business operating models under efficient budgets, shaped operations under the EU regulation, and cross-border frameworks. Led AI-driven transformations at Allianz, Candriam, and CACEIS across multiple markets. Columbia SIPA, MIT, and Polytechnique de Paris educated.',
      image: 'https://cqpenfycgbztkozuwfiu.supabase.co/storage/v1/object/sign/Professional%20Photos/Oualid%20Picture.png?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9kZjlmMTQ4My1mMmM0LTRjZTAtOWIxNi01N2E0Njk3ZWIxYjciLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJQcm9mZXNzaW9uYWwgUGhvdG9zL091YWxpZCBQaWN0dXJlLnBuZyIsImlhdCI6MTc1NjU0NzA5MiwiZXhwIjozMzI5MjU0NzA5Mn0.DZfC0ghbcciNDv2_N7Onk_J4VsbcNjqMQtPNlQeGhDU',
      social: {
        linkedin: '#',
        calendar: 'https://lunacal.ai/team/quantum-leverage',
        email: 'oualid@quantumleverage.com'
      }
    },
    {
      name: 'Christopher White',
      title: 'Chief Operating Officer',
      bio: 'Christopher White brings nearly two decades of distinguished service as a U.S. Army Officer, where he led at multiple levels of responsibility across operations, strategy, and organizational development. Over the course of his career, he built a record of success in leading teams, managing large-scale programs, and delivering results in high-pressure, mission-critical environments. His expertise spans leadership, program management, risk mitigation, technology integration, Artificial and Convolutional Neural Networks.',
      image: 'https://cqpenfycgbztkozuwfiu.supabase.co/storage/v1/object/sign/Professional%20Photos/Screenshot%202025-08-27%20at%2010.09.50%20AM.png?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9kZjlmMTQ4My1mMmM0LTRjZTAtOWIxNi01N2E0Njk3ZWIxYjciLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJQcm9mZXNzaW9uYWwgUGhvdG9zL1NjcmVlbnNob3QgMjAyNS0wOC0yNyBhdCAxMC4wOS41MCBBTS5wbmciLCJpYXQiOjE3NTYzMDM4MTUsImV4cCI6MzMyOTIzMDM4MTV9.gqwbwvEfa6DY5wGdV5BTgj7XJ5lKEPMZrd6pmYjmwIY',
      social: {
        linkedin: 'https://www.linkedin.com/in/christopher-white-2a772670/',
        calendar: 'https://lunacal.ai/team/quantum-leverage',
        email: 'christopher@quantumleverage.com'
      }
    }
  ];

  const advisors = [
    {
      name: 'Dr. Anna Stumpf',
      title: 'Director of Curriculum & Learning Innovation',
      bio: 'Dr. Anna Stumpf brings over 30 years of combined corporate and academic experience to Quantum Leverage, where she leads the design of innovative learning experiences. She has developed and led nationally ranked master\'s programs, developing online and asynchronous learning long before it was mainstream, and has trained thousands of professionals through workshops, coaching, and executive education. Earlier in her career, Anna spent a decade with Walmart developing leaders across the US. Today, through her company, Collective Energy, she helps organizations and individuals close the \'Double Skills Gap\' by equipping technical experts with the leadership and digital skills needed for the future of work. Anna is passionate about making learning practical, engaging, and transformative.',
      image: 'https://cqpenfycgbztkozuwfiu.supabase.co/storage/v1/object/sign/Professional%20Photos/Dr.%20Stumpf%20Photo.png?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9kZjlmMTQ4My1mMmM0LTRjZTAtOWIxNi01N2E0Njk3ZWIxYjciLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJQcm9mZXNzaW9uYWwgUGhvdG9zL0RyLiBTdHVtcGYgUGhvdG8ucG5nIiwiaWF0IjoxNzU2NTQ4Mjg2LCJleHAiOjMzMjkyNTQ4Mjg2fQ.HDg5RBmKyIA-jpnUpqjwp4ukDtf1bb6cTtQFDbce6fI',
      social: {
        linkedin: 'https://www.linkedin.com/in/amstumpf/',
        calendar: 'https://lunacal.ai/team/quantum-leverage',
        email: 'anna@quantumleverage.com'
      }
    },
    {
      name: 'Michal Aharon',
      title: 'AI Ethics Advisor',
      bio: 'Michal Aharon is a newsroom leader and AI ethics researcher with more than a decade of experience at the intersection of technology, media, and society. She has published in top-tier journals on responsible machine learning and contributed to ethical frameworks for the use of AI in digital environments. As Chief Assignment Editor at Haaretz, she managed large editorial teams and shaped investigative coverage, while also co-initiating the Haaretz Digital Editing Course to train the next generation of journalists in modern news practices. Michal holds a BA with honors in Philosophy, Political Science, and Economics (PPE) from Tel Aviv University and an MPA in Global Leadership from Columbia University, where she focused on AI governance and civil society innovation.',
      image: 'https://cqpenfycgbztkozuwfiu.supabase.co/storage/v1/object/sign/Professional%20Photos/Michael%20Prof.%20Pic.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9kZjlmMTQ4My1mMmM0LTRjZTAtOWIxNi01N2E0Njk3ZWIxYjciLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJQcm9mZXNzaW9uYWwgUGhvdG9zL01pY2hhZWwgUHJvZi4gUGljLmpwZyIsImlhdCI6MTc1NTk3MzI4MCwiZXhwIjozMzI5MTk3MzI4MH0.FHqSAAupAAKHEVKJhwiRogXmxSAm5tnzVcMffz5MvBk',
      social: {
        linkedin: 'https://www.linkedin.com/in/michalaharon/',
        calendar: 'https://lunacal.ai/team/quantum-leverage',
        email: 'michal@quantumleverage.com'
      }
    },
    {
      name: 'Zachary Coles',
      title: 'Business Strategy Advisor',
      bio: 'Zachary is a business strategist with over a decade of project management experience, specializing in IT growth strategy and operational efficiency within the Department of Defense. He has led complex technology initiatives, advised senior leaders, and driven organizational improvements that align mission objectives with sustainable outcomes. Zachary brings a proven ability to bridge business and technology, helping organizations scale effectively while strengthening operational resilience.',
      image: 'https://cqpenfycgbztkozuwfiu.supabase.co/storage/v1/object/sign/Professional%20Photos/IMG_9230.JPEG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9kZjlmMTQ4My1mMmM0LTRjZTAtOWIxNi01N2E0Njk3ZWIxYjciLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJQcm9mZXNzaW9uYWwgUGhvdG9zL0lNR185MjMwLkpQRUciLCJpYXQiOjE3NTU5NTY4MzMsImV4cCI6MzMyOTE5NTY4MzN9.xPm1mXZy4suK35v-RSgAM5NlTqddVy4y1lLEpyWguGM',
      social: {
        linkedin: 'https://www.linkedin.com/in/zachary-coles-071911/',
        calendar: 'https://lunacal.ai/team/quantum-leverage',
        email: 'zachary@quantumleverage.com'
      }
    },
    {
      name: 'Ian Reynoso',
      title: 'Chief Information Security Advisor',
      bio: 'Ian is a cybersecurity strategist and digital innovator with over a decade of experience across government and private sectors. He has led advanced cyber operations, built global partnerships, and advised public and private leaders navigating some of the world\'s most complex digital environments. Ian specializes in designing secure, scalable cyber ecosystems that drive both resilience and growth.',
      image: 'https://cqpenfycgbztkozuwfiu.supabase.co/storage/v1/object/sign/Professional%20Photos/Image%208-28-25%20at%2012.54%20PM.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9kZjlmMTQ4My1mMmM0LTRjZTAtOWIxNi01N2E0Njk3ZWIxYjciLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJQcm9mZXNzaW9uYWwgUGhvdG9zL0ltYWdlIDgtMjgtMjUgYXQgMTIuNTQgUE0uanBnIiwiaWF0IjoxNzU2NDAwMjk4LCJleHAiOjMzMjkyNDAwMjk4fQ.axilpor2O5XHww0fB3g3OaxB48_xk6nyIH-iS4FHDcc',
      social: {
        linkedin: '#',
        calendar: 'https://lunacal.ai/team/quantum-leverage',
        email: 'ian@quantumleverage.com'
      }
    },
    {
      name: 'Daniel Grajeda',
      title: 'Design & User Experience Advisor',
      bio: 'Military Diplomat with a career spanning military leadership, international diplomacy, security cooperation and organizational development. He brings a unique perspective to design and innovation focused on creating user-centered systems that simplify complexity and better prepares leaders to manage future challenges.',
      image: 'https://cqpenfycgbztkozuwfiu.supabase.co/storage/v1/object/sign/Professional%20Photos/IMG_3371.JPG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9kZjlmMTQ4My1mMmM0LTRjZTAtOWIxNi01N2E0Njk3ZWIxYjciLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJQcm9mZXNzaW9uYWwgUGhvdG9zL0lNR18zMzcxLkpQRyIsImlhdCI6MTc1NTk1NjMzNSwiZXhwIjozMzI5MTk1NjMzNX0.kswixYrjOhFGV1L6x5deO0zoiQY3zGO4dWuf00R0l4I',
      social: {
        linkedin: 'https://www.linkedin.com/in/daniel-grajeda-634aabb4/',
        calendar: 'https://lunacal.ai/team/quantum-leverage',
        email: 'daniel@quantumleverage.com'
      }
    }
  ];

  return (
    <div className="pt-24 pb-16">
      {/* Hero Section */}
      <section className="relative py-24 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center space-y-8"
          >
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.8 }}
              className="text-5xl md:text-6xl font-bold leading-tight"
            >
              Meet Our <span className="gradient-text">Team</span>
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.8 }}
              className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed"
            >
              The brilliant minds behind Quantum Leverage's transformational technology
            </motion.p>
          </motion.div>
          {/* Background Elements */}
          <div className="absolute top-1/3 left-1/4 w-64 h-64 bg-primary-orange/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-primary-orange/3 rounded-full blur-3xl"></div>
        </div>
      </section>

      {/* Executive Team */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="space-y-16"
          >
            <div className="text-center space-y-4">
              <h2 className="text-4xl font-bold">
                Executive <span className="gradient-text">Leadership</span>
              </h2>
              <div className="h-1 w-24 bg-primary-orange mx-auto"></div>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12">
              {executiveTeam.map((member, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.2, duration: 0.8 }}
                  viewport={{ once: true }}
                  className="glass-effect p-8 text-center space-y-6 group hover:bg-gray-900/50 transition-all duration-300"
                >
                  {/* Profile Image */}
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    className="relative mx-auto w-48 h-48 overflow-hidden tech-border"
                  >
                    <img
                      src={member.image}
                      alt={member.name}
                      className={`w-full h-full ${
                        member.name === 'Christopher White' || member.name === 'Oualid Ouardi'
                          ? 'object-cover object-top' 
                          : 'object-cover object-center'
                      }`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                  </motion.div>

                  {/* Info */}
                  <div className="space-y-3">
                    <h3 className="text-2xl font-bold group-hover:text-primary-orange transition-colors">
                      {member.name}
                    </h3>
                    <p className="text-primary-orange font-semibold">{member.title}</p>
                    <p className="text-gray-300 leading-relaxed">{member.bio}</p>
                  </div>

                  {/* Social Links */}
                  <div className="flex justify-center space-x-4 pt-4">
                    <motion.a
                      href={member.social.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      whileHover={{ scale: 1.1, y: -2 }}
                      className="w-10 h-10 bg-gray-800 hover:bg-primary-orange flex items-center justify-center transition-all duration-200 group/social"
                      aria-label={`Visit ${member.name}'s LinkedIn profile`}
                    >
                      <SafeIcon
                        icon={FiLinkedin}
                        className="w-5 h-5 text-gray-300 group-hover/social:text-black transition-colors"
                      />
                    </motion.a>
                    <motion.a
                      href={member.social.calendar}
                      target="_blank"
                      rel="noopener noreferrer"
                      whileHover={{ scale: 1.1, y: -2 }}
                      className="w-10 h-10 bg-gray-800 hover:bg-primary-orange flex items-center justify-center transition-all duration-200 group/social"
                      aria-label={`Book a meeting with ${member.name}`}
                    >
                      <SafeIcon
                        icon={FiCalendar}
                        className="w-5 h-5 text-gray-300 group-hover/social:text-black transition-colors"
                      />
                    </motion.a>
                    <motion.a
                      href={`mailto:${member.social.email}`}
                      whileHover={{ scale: 1.1, y: -2 }}
                      className="w-10 h-10 bg-gray-800 hover:bg-primary-orange flex items-center justify-center transition-all duration-200 group/social"
                      aria-label={`Send email to ${member.name}`}
                    >
                      <SafeIcon
                        icon={FiMail}
                        className="w-5 h-5 text-gray-300 group-hover/social:text-black transition-colors"
                      />
                    </motion.a>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Advisors - Vertical Layout */}
      <section className="py-16 bg-gray-950">
        <div className="max-w-5xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="space-y-16"
          >
            <div className="text-center space-y-4">
              <h2 className="text-4xl font-bold">
                Strategic <span className="gradient-text">Advisors</span>
              </h2>
              <div className="h-1 w-24 bg-primary-orange mx-auto"></div>
            </div>

            <div className="space-y-12">
              {advisors.map((advisor, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.2, duration: 0.8 }}
                  viewport={{ once: true }}
                  className="glass-effect p-10 text-center space-y-8 group hover:bg-gray-900/50 transition-all duration-300"
                >
                  {/* Profile Image */}
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    className="relative mx-auto w-40 h-40 overflow-hidden tech-border"
                  >
                    <img
                      src={advisor.image}
                      alt={advisor.name}
                      className={`w-full h-full ${
                        advisor.name === 'Daniel Grajeda' 
                          ? 'object-cover object-top' 
                          : 'object-cover'
                      }`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                  </motion.div>

                  {/* Info */}
                  <div className="space-y-3">
                    <h3 className="text-2xl font-bold group-hover:text-primary-orange transition-colors">
                      {advisor.name}
                    </h3>
                    <p className="text-primary-orange font-semibold">{advisor.title}</p>
                    {advisor.bio && (
                      <p className="text-gray-300 leading-relaxed max-w-4xl mx-auto">{advisor.bio}</p>
                    )}
                  </div>

                  {/* Social Links */}
                  <div className="flex justify-center space-x-4 pt-4">
                    <motion.a
                      href={advisor.social.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      whileHover={{ scale: 1.1, y: -2 }}
                      className="w-10 h-10 bg-gray-800 hover:bg-primary-orange flex items-center justify-center transition-all duration-200 group/social"
                      aria-label={`Visit ${advisor.name}'s LinkedIn profile`}
                    >
                      <SafeIcon
                        icon={FiLinkedin}
                        className="w-5 h-5 text-gray-300 group-hover/social:text-black transition-colors"
                      />
                    </motion.a>
                    <motion.a
                      href={advisor.social.calendar}
                      target="_blank"
                      rel="noopener noreferrer"
                      whileHover={{ scale: 1.1, y: -2 }}
                      className="w-10 h-10 bg-gray-800 hover:bg-primary-orange flex items-center justify-center transition-all duration-200 group/social"
                      aria-label={`Book a meeting with ${advisor.name}`}
                    >
                      <SafeIcon
                        icon={FiCalendar}
                        className="w-5 h-5 text-gray-300 group-hover/social:text-black transition-colors"
                      />
                    </motion.a>
                    <motion.a
                      href={`mailto:${advisor.social.email}`}
                      whileHover={{ scale: 1.1, y: -2 }}
                      className="w-10 h-10 bg-gray-800 hover:bg-primary-orange flex items-center justify-center transition-all duration-200 group/social"
                      aria-label={`Send email to ${advisor.name}`}
                    >
                      <SafeIcon
                        icon={FiMail}
                        className="w-5 h-5 text-gray-300 group-hover/social:text-black transition-colors"
                      />
                    </motion.a>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Join Our Team CTA */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="glass-effect p-12 text-center space-y-8"
          >
            <h2 className="text-3xl font-bold">
              Join Our <span className="gradient-text">Mission</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              We're always looking for exceptional talent to help us build the future of transformation technology.
            </p>
            <motion.div className="pt-4">
              <motion.a
                href="mailto:careers@quantumleverage.com"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-primary-orange text-black px-8 py-4 font-semibold text-lg hover:bg-primary-dark transition-all duration-200 inline-block"
              >
                View Open Positions
              </motion.a>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default TeamPage;